import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useWindowSize from 'Hooks/useWindowSize';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
  },
  side: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
  main: {
    background: theme.gradients.vertical.primaryToAccentBlue,
  },
  [theme.breakpoints.up('lg')]: {
    root: {},
    main: {
      borderRadius: theme.radius.none,
      borderBottomLeftRadius: theme.radius.sm,
      marginLeft: theme.dimensions.md,
      width: '100%',
    },
    side: {
      position: 'fixed',
      width: theme.dimensions.md,
    },
  },
  [theme.breakpoints.down('md')]: {
    root: {
      flexDirection: 'column',
    },
    side: {
      flexBasis: '100%',
    },
    main: {
      overflowY: 'inherit',
      flexBasis: '100%',
      borderRadius: theme.radius.none,
      height: 'auto',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
  },
}));

export default function SplitView({ description, children }) {
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const height = useWindowSize()[1];
  const contentHeight = height - theme.heights.clientNavigationHeight - theme.heights.footerHeight;
  const sideStyle = isDesktop ? { height: contentHeight } : null;
  const mainStyle = isDesktop ? { minHeight: contentHeight } : null;

  return (
    <div className={classes.root}>
      <div className={classes.side} style={sideStyle}>
        {description}
      </div>
      <Paper
        className={classes.main}
        elevation={isDesktop ? 10 : 0}
        style={mainStyle}
      >
        {children}
      </Paper>
    </div>
  );
}

SplitView.propTypes = {
  description: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};
